var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(_vm.from)+" t/m "+_vm._s(_vm.to)+" van "+_vm._s(_vm._f("numberFormatNL")(_vm.total))+" "+_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }